import { Component, inject, input } from "@angular/core";
import { FormArray, FormGroup } from "@angular/forms";

import { RulesetsBuilderService } from "@components/settings/settings-rulesets/rulesets-builder.service";
import { InputSelectOption } from "@components/shared/inputs/input-select/input-select.model";
import { IExpectationItemForm } from "@shared/interfaces/ruleset.interface";

@Component({
  selector: "app-expectation-group",
  templateUrl: "./expectation-group.component.html",
  styleUrls: ["./expectation-group.component.scss"],
  standalone: false,
})
export class ExpectationGroupComponent {
  expectationsFormArray = input<FormArray<FormGroup<IExpectationItemForm>>>();

  valueOptions = input<InputSelectOption[]>();

  isReadOnly = input<boolean>(false);

  private rulesetsBuilderService = inject(RulesetsBuilderService);

  get expectationForms(): FormGroup<IExpectationItemForm>[] {
    return this.expectationsFormArray().controls;
  }

  addExpectation(): void {
    this.expectationsFormArray().push(
      this.rulesetsBuilderService.buildDefaultExpectationItemForm(),
    );
  }

  removeExpectation(index: number): void {
    this.expectationsFormArray().removeAt(index);
  }
}
